import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'recompose';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import { BasicMain, injectIntl } from 'components';
import { withTracker } from 'components/Tracker';

import PricingCard from './PricingCard';

const prices = [
  {
    title: 'Farms',
    availables: [
      'Unlimited Customers',
      'Payment Platform',
      'Help center access',
      'Phone & email support',
    ],
    buttonText: 'Sign up for Free',
    buttonVariant: 'outlined',
  },
  {
    title: 'Distributors',
    availables: [
      'Unlimited Customers & Vendors',
      'Payments Platform',
      'Help center access',
      'Phone & email support',
    ],
    buttonText: 'Get Started',
    buttonVariant: 'contained',
  },
  // {
  //   title: 'Restaurants & Grocers',
  //   availables: [
  //     'Unlimited Vendors',
  //     'Payments Platform',
  //     'Help center access',
  //     'Phone & email support',
  //   ],
  //   buttonText: 'Sign up for Free',
  //   buttonVariant: 'outlined',
  // },
];

const styles = theme => ({
  bottomSpacing: { marginBottom: theme.spacing.unit * 3 },
});

const Pricing = ({ classes, formatMessage }, { globals }) => (
  <BasicMain>
    <Typography className={classes.bottomSpacing} variant="h4" align="center" color="textPrimary">
      {formatMessage('Pricing')}
    </Typography>
    <Typography className={classes.bottomSpacing} variant="subtitle2" align="center" color="textSecondary">
      {formatMessage('Quickly build a Storefront or Order from your favorite Vendors')}
    </Typography>
    <Grid container spacing={40} alignItems="flex-end">
      {prices.map(pricing => (
        <PricingCard
          key={pricing.title}
          pricing={pricing}
          value={globals.monthlySubscriptionFee}
          formatMessage={formatMessage}
        />
      ))}
    </Grid>
  </BasicMain>
);

Pricing.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  formatMessage: PropTypes.func.isRequired,
};

Pricing.contextTypes = {
  globals: PropTypes.shape({}),
};

export default compose(
  setDisplayName('Pricing'),
  injectIntl,
  withStyles(styles),
  withTracker,
)(Pricing);
